var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('o-section',{attrs:{"overlay":true}},[_c('p',[_vm._v("Geef aan hoe ver u met de elektrische wagen wil rijden.")]),_c('o-text-input',{attrs:{"label":"Aantal kilometer","placeholder":"0","type":"number"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }